export const ENABLE_SHIPPING_CATEGORY   = 'shipping.enable_shipping';
export const NEXT_BUSINESS_DAY          = 'NEXT_BUSINESS_DAY';
export const CARRIER_TYPES              = ['UPS', 'LTL', 'FEDEX'];

/**
 * UPS Related Logic
 */
export const DOMESTIC_SERVICE_TYPES     = ['1DM', '1DA', '1DP', '2DA', '2DM', '3DS', 'GND', 'M4'];
export const DOMESTIC_SERVICE_TYPES_SATURDAY = ['1DAS', '1DM', '1DA', '1DP', '2DA', '2DM', '3DS', 'GND', 'M4'];
export const INTL_SERVICE_TYPES         = ['01', '03', '05', '21', '28'];
export const PR_SERVICE_TYPES           = ['1DA', '2DA', 'GND'];
export const MAG_DOMESTIC_SERVICE_TYPES = ['ups_14', 'ups_01', 'ups_13', 'ups_02', 'ups_59', 'ups_12', 'ups_03', 'usps_4'];
export const MAG_INTL_SERVICE_TYPES     = ['ups_07', 'ups_11', 'ups_08', 'ups_54', 'ups_65'];

export const fromAddress = {
  address_line_1: '6987 CALLE DE LINEA',
  city          : 'San Diego',
  state_code    : 'CA',
  postal_code   : '92154',
  country_code  : 'US'
};

/**
 * Shipment Estimates to Delivery Code Mapping
    {
      ** International & Other
      UPS Standard              : 03 -> 11
      UPS Worldwide Expedited   : 05 -> 08
      UPS Worldwide Express     : 01 -> 07
      UPS Worldwide Express Plus: 21 -> 54
      UPS Worldwide Saver       : 28 -> 65

      ** Domestic
      UPS Next Day Air Early: 1DM -> 14
      UPS Next Day Air      : 1DA -> 01
      UPS Next Day Air Saver: 1DP -> 13
      UPS 2nd Day Air       : 2DA -> 02
      UPS 2nd Day Air A.M.  : 2DM -> 59
      UPS 3 Day Select      : 3DS -> 12
      UPS Ground            : GND -> 03
      UPS Mail Innovations: M4
    }

 */

export const deliveryDisplayTypes = {
  '01' : 'UPS Next Day Air',
  '01S': 'UPS Next Day Air (Saturday)',
  '02' : 'UPS 2nd Day Air',
  '02S': 'UPS 2nd Day Air (Saturday)',
  '03' : 'UPS Ground',
  '07' : 'UPS Standard',
  '08' : 'UPS Worldwide Expedited',
  '11' : 'UPS Worldwide Express',
  '12' : 'UPS 3 Day Select',
  '13' : 'UPS Next Day Air Saver',
  '14' : 'UPS Next Day Air Early',
  '14S': 'UPS Next Day Air Early (Saturday)',
  '54' : 'UPS Worldwide Express Plus',
  '59' : 'UPS 2nd Day Air A.M.',
  '65' : 'UPS Worldwide Saver',
  'M4' : 'UPS Mail Innovations',

  'ups_01' : 'UPS Next Day Air',
  'ups_01S': 'UPS Next Day Air (Saturday)',
  'ups_02' : 'UPS 2nd Day Air',
  'ups_02S': 'UPS 2nd Day Air (Saturday)',
  'ups_03' : 'UPS Ground',
  'ups_07' : 'UPS Standard',
  'ups_08' : 'UPS Worldwide Expedited',
  'ups_11' : 'UPS Worldwide Express',
  'ups_12' : 'UPS 3 Day Select',
  'ups_13' : 'UPS Next Day Air Saver',
  'ups_14' : 'UPS Next Day Air Early',
  'ups_14S': 'UPS Next Day Air Early (Saturday)',
  'ups_54' : 'UPS Worldwide Express Plus',
  'ups_59' : 'UPS 2nd Day Air A.M.',
  'ups_65' : 'UPS Worldwide Saver',

  // freeshipping_freeshipping: 'UPS Mail Innovations',
  freeshipping_usps_0_FCP  : 'UPS Mail Innovations',
  freeshipping_freeshipping: 'UPS Ground',
  freeshipping_ups01       : 'UPS Next Day Air',
  freeshipping_ups02       : 'UPS 2nd Day Air',
  freeshipping_ups03       : 'UPS Ground',
  freeshipping_ups_01      : 'UPS Next Day Air',
  freeshipping_ups_02      : 'UPS 2nd Day Air',
  freeshipping_ups_03      : 'UPS Ground',
  // flatrate_flatrate        : 'UPS Mail Innovations',
  flatrate_flatrate        : 'UPS Ground',
  flatrate_ups_03          : 'UPS Ground',
  flatrate_ups_02          : 'UPS 2nd Day Air',
  flatrate_ups_01          : 'UPS Next Day Air',
  superrush_superrush      : 'UPS Next Day Air',
  ups_gnd                  : 'UPS Ground',
  ups_1da                  : 'UPS Next Day Air',
  ups_2da                  : 'UPS 2nd Day Air',

  // UPS Mail Innovations Methods
  usps_0_fcle                           : 'UPS Mail Innovations',   // First Class Mail Large Envelope
  usps_0_fcl                            : 'UPS Mail Innovations',   // First Class Mail Letter
  usps_0_fcp                            : 'UPS Mail Innovations',   // First Class Mail Parcel
  usps_0_fcpc                           : 'UPS Mail Innovations',   // First Class Mail Postcards
  usps_1                                : 'UPS Mail Innovations',   // Priority Mail
  usps_2                                : 'UPS Mail Innovations',   // Priority Mail Express Hold For Pickup
  usps_3                                : 'UPS Mail Innovations',   // Priority Mail Express
  usps_4                                : 'UPS Mail Innovations',   // Standard Post
  usps_6                                : 'UPS Mail Innovations',   // Media Mail
  usps_7                                : 'UPS Mail Innovations',   // Library Mail
  usps_13                               : 'UPS Mail Innovations',   // Priority Mail Express Flat Rate Envelope
  usps_15                               : 'UPS Mail Innovations',   // First Class Mail Large Postcards
  usps_16                               : 'UPS Mail Innovations',   // Priority Mail Flat Rate Envelope
  usps_17                               : 'UPS Mail Innovations',   // Priority Mail Medium Flat Rate Box
  usps_22                               : 'UPS Mail Innovations',   // Priority Mail Large Flat Rate Box
  usps_23                               : 'UPS Mail Innovations',   // Priority Mail Express Sunday/Holiday Delivery
  usps_25                               : 'UPS Mail Innovations',   // Priority Mail Express Sunday/Holiday Delivery Flat Rate Envelope
  usps_27                               : 'UPS Mail Innovations',   // Priority Mail Express Flat Rate Envelope Hold For Pickup
  usps_28                               : 'UPS Mail Innovations',   // Priority Mail Small Flat Rate Box
  usps_29                               : 'UPS Mail Innovations',   // Priority Mail Padded Flat Rate Envelope
  usps_30                               : 'UPS Mail Innovations',   // Priority Mail Express Legal Flat Rate Envelope
  usps_31                               : 'UPS Mail Innovations',   // Priority Mail Express Legal Flat Rate Envelope Hold For Pickup
  usps_32                               : 'UPS Mail Innovations',   // Priority Mail Express Sunday/Holiday Delivery Legal Flat Rate Envelope
  usps_33                               : 'UPS Mail Innovations',   // Priority Mail Hold For Pickup
  usps_34                               : 'UPS Mail Innovations',   // Priority Large Flat Rate Box Hold For Pickup
  usps_35                               : 'UPS Mail Innovations',   // Priority Medium Flat Rate Box Hold For Pickup
  usps_36                               : 'UPS Mail Innovations',   // Priority Small Flat Rate Box Hold For Pickup
  usps_37                               : 'UPS Mail Innovations',   // Priority Mail Flat Rate Envelope Hold For Pickup
  usps_38                               : 'UPS Mail Innovations',   // Priority Mail Gift Card Flat Rate Envelope
  usps_39                               : 'UPS Mail Innovations',   // Priority Mail Gift Card Flat Rate Envelope Hold For Pickup
  usps_40                               : 'UPS Mail Innovations',   // Priority Mail Window Flat Rate Envelope
  usps_41                               : 'UPS Mail Innovations',   // Priority Mail Window Flat Rate Envelope Hold For Pickup
  usps_42                               : 'UPS Mail Innovations',   // Priority Mail Small Flat Rate Envelope
  usps_43                               : 'UPS Mail Innovations',   // Priority Mail Small Flat Rate Envelope Hold For Pickup
  usps_44                               : 'UPS Mail Innovations',   // Priority Mail Legal Flat Rate Envelope
  usps_45                               : 'UPS Mail Innovations',   // Priority Mail Legal Flat Rate Envelope Hold For Pickup
  usps_46                               : 'UPS Mail Innovations',   // Priority Mail Padded Flat Rate Envelope Hold For Pickup
  usps_47                               : 'UPS Mail Innovations',   // Priority Mail Regional Rate Box A
  usps_48                               : 'UPS Mail Innovations',   // Priority Mail Regional Rate Box A Hold For Pickup
  usps_49                               : 'UPS Mail Innovations',   // Priority Mail Regional Rate Box B
  usps_50                               : 'UPS Mail Innovations',   // Priority Mail Regional Rate Box B Hold For Pickup
  usps_53                               : 'UPS Mail Innovations',   // First Class Package Service Hold For Pickup
  usps_55                               : 'UPS Mail Innovations',   // Priority Mail Express Flat Rate Boxes
  usps_56                               : 'UPS Mail Innovations',   // Priority Mail Express Flat Rate Boxes Hold For Pickup
  usps_57                               : 'UPS Mail Innovations',   // Priority Mail Express Sunday/Holiday Delivery Flat Rate Boxes
  usps_58                               : 'UPS Mail Innovations',   // Priority Mail Regional Rate Box C
  usps_59                               : 'UPS Mail Innovations',   // Priority Mail Regional Rate Box C Hold For Pickup
  usps_61                               : 'UPS Mail Innovations',   // First Class Package Service
  usps_62                               : 'UPS Mail Innovations',   // Priority Mail Express P Added Flat Rate Envelope
  usps_63                               : 'UPS Mail Innovations',   // Priority Mail Express Padded Flat Rate Envelope Hold For Pickup
  usps_64                               : 'UPS Mail Innovations',   // Priority Mail Express Sunday/Holiday Delivery Padded Flat Rate Envelope
  usps_int_1                            : 'UPS Mail Innovations',   // Priority Mail Express International
  usps_int_2                            : 'UPS Mail Innovations',   // Priority Mail International
  usps_int_4                            : 'UPS Mail Innovations',   // Global Express Guaranteed (GXG)
  usps_int_5                            : 'UPS Mail Innovations',   // Global Express Guaranteed Document
  usps_int_6                            : 'UPS Mail Innovations',   // Global Express Guaranteed Non-Document Rectangular
  usps_int_7                            : 'UPS Mail Innovations',   // Global Express Guaranteed Non-Document Non-Rectangular
  usps_int_8                            : 'UPS Mail Innovations',   // Priority Mail International Flat Rate Envelope
  usps_int_9                            : 'UPS Mail Innovations',   // Priority Mail International Medium Flat Rate Box
  usps_int_10                           : 'UPS Mail Innovations',   // Priority Mail Express International Flat Rate Envelope
  usps_int_11                           : 'UPS Mail Innovations',   // Priority Mail International Large Flat Rate Box
  usps_int_12                           : 'UPS Mail Innovations',   // USPS GXG Envelopes
  usps_int_13                           : 'UPS Mail Innovations',   // First Class Mail International Letter
  usps_int_14                           : 'UPS Mail Innovations',   // First Class Mail International Large Envelope
  usps_int_15                           : 'UPS Mail Innovations',   // First Class Package International Service
  usps_int_16                           : 'UPS Mail Innovations',   // Priority Mail Interntional Small Flat Rate Box
  usps_int_17                           : 'UPS Mail Innovations',   // Priority Mail Express International Legal Flat Rate Envelope
  usps_int_18                           : 'UPS Mail Innovations',   // Priority Mail International Gift Card Flat Rate Envelope
  usps_int_19                           : 'UPS Mail Innovations',   // Priority Mail International Window Flat Rate Envelope
  usps_int_20                           : 'UPS Mail Innovations',   // Priority Mail International Small Flat Rate Envelope
  usps_int_21                           : 'UPS Mail Innovations',   // First Class Mail International Postcard
  usps_int_22                           : 'UPS Mail Innovations',   // Priority Mail International Legal Flat Rate Envelope
  usps_int_23                           : 'UPS Mail Innovations',   // Priority Mail International Padded Flat Rate Envelope
  usps_int_24                           : 'UPS Mail Innovations',   // Priority Mail International DVD Flat Rate Priced Box
  usps_int_25                           : 'UPS Mail Innovations',   // Priority Mail International Large Video Flat Rate Priced Box
  usps_int_26                           : 'UPS Mail Innovations',   // Priority Mail Express International Flat Rate Boxes
  usps_int_27                           : 'UPS Mail Innovations',   // Priority Mail Express International Padded Flat Rate Envelope
  'usps_first-class_mail_parcel'        : 'UPS Mail Innovations',
  'usps_first-class_mail_large_envelope': 'UPS Mail Innovations'
};

export const magIntlTypes = {
  '01': 'ups_07', // UPS Worldwide Express
  '03': 'ups_11', // UPS Standard
  '05': 'ups_08', // UPS Worldwide Expedited
  '21': 'ups_54', // UPS Worldwide Express Plus
  '28': 'ups_65', // UPS Worldwide Saver
  '65': 'ups_65', // UPS Worldwide Saver

  freeshipping_freeshipping: 'ups_65',
  freeshipping_ups01 : 'ups_08',
  freeshipping_ups02 : 'ups_08',
  freeshipping_ups03 : 'ups_65',
  freeshipping_ups_01: 'ups_08',
  freeshipping_ups_02: 'ups_08',
  freeshipping_ups_03: 'ups_65',
  flatrate_flatrate  : 'ups_65',
  superrush_superrush: 'ups_08',
  ups_01             : 'ups_08',
  ups_02             : 'ups_08',
  ups_03             : 'ups_65',
  ups_07             : 'ups_07',
  ups_08             : 'ups_08',
  ups_11             : 'ups_11',
  ups_28             : 'ups_28',
  ups_54             : 'ups_54',
  ups_65             : 'ups_65'
};

export const magShipmentTypes = {
  '1DM' : 'ups_14',   // UPS Next Day Air Early A.M.
  '1DMS': 'ups_14S',  // UPS Next Day Air Early A.M. (Saturday Delivery)
  '1DA' : 'ups_01',   // UPS Next Day Air
  '1DAS': 'ups_01S',  // UPS Next Day Air (Saturday Delivery)
  '1DP' : 'ups_13',   // UPS Next Day Air Saver
  '2DA' : 'ups_02',   // UPS 2nd Day Air
  '2DAS': 'ups_02S',  // UPS 2nd Day Air (Saturday Delivery)
  '2DM' : 'ups_59',   // UPS 2nd Day Air A.M.
  '3DS' : 'ups_12',   // UPS 3 Day Select
  'GND' : 'ups_03',   // UPS Ground
  'M4'  : 'usps_4',   // UPS Mail Innovations

  '01': 'ups_07',   // UPS Worldwide Express
  '03': 'ups_11',   // UPS Standard
  '05': 'ups_08',   // UPS Worldwide Expedited
  '21': 'ups_54',   // UPS Worldwide Express Plus
  '65': 'ups_65',   // UPS Worldwide Saver

  // freeshipping_freeshipping: 'usps_4',
  'freeshipping_usps_0_FCP': 'usps_4',   // UPS Mail Innovations
  freeshipping_freeshipping: 'ups_03',
  freeshipping_ups01       : 'ups_01',
  freeshipping_ups02       : 'ups_02',
  freeshipping_ups03       : 'ups_03',
  freeshipping_ups_01      : 'ups_01',
  freeshipping_ups_02      : 'ups_02',
  freeshipping_ups_03      : 'ups_03',
  // flatrate_flatrate        : 'usps_4',
  flatrate_flatrate        : 'ups_03',
  flatrate_ups_03          : 'ups_03',
  flatrate_ups_02          : 'ups_02',
  flatrate_ups_01          : 'ups_01',
  superrush_superrush      : 'ups_01',
  ups_01                   : 'ups_01',
  ups_01S                  : 'ups_01S',
  ups_02                   : 'ups_02',
  ups_02S                  : 'ups_02S',
  ups_03                   : 'ups_03',
  ups_07                   : 'ups_07',
  ups_08                   : 'ups_08',
  ups_11                   : 'ups_11',
  ups_12                   : 'ups_12',
  ups_13                   : 'ups_13',
  ups_14                   : 'ups_14',
  ups_14S                  : 'ups_14S',
  ups_54                   : 'ups_54',
  ups_59                   : 'ups_59',
  ups_65                   : 'ups_65',
  ups_gnd                  : 'ups_03',
  ups_1da                  : 'ups_01',
  ups_2da                  : 'ups_02',

  // UPS Mail Innovations Methods
  usps_0_fcle                           : 'usps_4',   // First Class Mail Large Envelope
  usps_0_fcl                            : 'usps_4',   // First Class Mail Letter
  usps_0_fcp                            : 'usps_4',   // First Class Mail Parcel
  usps_0_fcpc                           : 'usps_4',   // First Class Mail Postcards
  usps_1                                : 'usps_4',   // Priority Mail
  usps_2                                : 'usps_4',   // Priority Mail Express Hold For Pickup
  usps_3                                : 'usps_4',   // Priority Mail Express
  usps_4                                : 'usps_4',   // Standard Post
  usps_6                                : 'usps_4',   // Media Mail
  usps_7                                : 'usps_4',   // Library Mail
  usps_13                               : 'usps_4',   // Priority Mail Express Flat Rate Envelope
  usps_15                               : 'usps_4',   // First Class Mail Large Postcards
  usps_16                               : 'usps_4',   // Priority Mail Flat Rate Envelope
  usps_17                               : 'usps_4',   // Priority Mail Medium Flat Rate Box
  usps_22                               : 'usps_4',   // Priority Mail Large Flat Rate Box
  usps_23                               : 'usps_4',   // Priority Mail Express Sunday/Holiday Delivery
  usps_25                               : 'usps_4',   // Priority Mail Express Sunday/Holiday Delivery Flat Rate Envelope
  usps_27                               : 'usps_4',   // Priority Mail Express Flat Rate Envelope Hold For Pickup
  usps_28                               : 'usps_4',   // Priority Mail Small Flat Rate Box
  usps_29                               : 'usps_4',   // Priority Mail Padded Flat Rate Envelope
  usps_30                               : 'usps_4',   // Priority Mail Express Legal Flat Rate Envelope
  usps_31                               : 'usps_4',   // Priority Mail Express Legal Flat Rate Envelope Hold For Pickup
  usps_32                               : 'usps_4',   // Priority Mail Express Sunday/Holiday Delivery Legal Flat Rate Envelope
  usps_33                               : 'usps_4',   // Priority Mail Hold For Pickup
  usps_34                               : 'usps_4',   // Priority Large Flat Rate Box Hold For Pickup
  usps_35                               : 'usps_4',   // Priority Medium Flat Rate Box Hold For Pickup
  usps_36                               : 'usps_4',   // Priority Small Flat Rate Box Hold For Pickup
  usps_37                               : 'usps_4',   // Priority Mail Flat Rate Envelope Hold For Pickup
  usps_38                               : 'usps_4',   // Priority Mail Gift Card Flat Rate Envelope
  usps_39                               : 'usps_4',   // Priority Mail Gift Card Flat Rate Envelope Hold For Pickup
  usps_40                               : 'usps_4',   // Priority Mail Window Flat Rate Envelope
  usps_41                               : 'usps_4',   // Priority Mail Window Flat Rate Envelope Hold For Pickup
  usps_42                               : 'usps_4',   // Priority Mail Small Flat Rate Envelope
  usps_43                               : 'usps_4',   // Priority Mail Small Flat Rate Envelope Hold For Pickup
  usps_44                               : 'usps_4',   // Priority Mail Legal Flat Rate Envelope
  usps_45                               : 'usps_4',   // Priority Mail Legal Flat Rate Envelope Hold For Pickup
  usps_46                               : 'usps_4',   // Priority Mail Padded Flat Rate Envelope Hold For Pickup
  usps_47                               : 'usps_4',   // Priority Mail Regional Rate Box A
  usps_48                               : 'usps_4',   // Priority Mail Regional Rate Box A Hold For Pickup
  usps_49                               : 'usps_4',   // Priority Mail Regional Rate Box B
  usps_50                               : 'usps_4',   // Priority Mail Regional Rate Box B Hold For Pickup
  usps_53                               : 'usps_4',   // First Class Package Service Hold For Pickup
  usps_55                               : 'usps_4',   // Priority Mail Express Flat Rate Boxes
  usps_56                               : 'usps_4',   // Priority Mail Express Flat Rate Boxes Hold For Pickup
  usps_57                               : 'usps_4',   // Priority Mail Express Sunday/Holiday Delivery Flat Rate Boxes
  usps_58                               : 'usps_4',   // Priority Mail Regional Rate Box C
  usps_59                               : 'usps_4',   // Priority Mail Regional Rate Box C Hold For Pickup
  usps_61                               : 'usps_4',   // First Class Package Service
  usps_62                               : 'usps_4',   // Priority Mail Express P Added Flat Rate Envelope
  usps_63                               : 'usps_4',   // Priority Mail Express Padded Flat Rate Envelope Hold For Pickup
  usps_64                               : 'usps_4',   // Priority Mail Express Sunday/Holiday Delivery Padded Flat Rate Envelope
  usps_int_1                            : 'usps_4',   // Priority Mail Express International
  usps_int_2                            : 'usps_4',   // Priority Mail International
  usps_int_4                            : 'usps_4',   // Global Express Guaranteed (GXG)
  usps_int_5                            : 'usps_4',   // Global Express Guaranteed Document
  usps_int_6                            : 'usps_4',   // Global Express Guaranteed Non-Document Rectangular
  usps_int_7                            : 'usps_4',   // Global Express Guaranteed Non-Document Non-Rectangular
  usps_int_8                            : 'usps_4',   // Priority Mail International Flat Rate Envelope
  usps_int_9                            : 'usps_4',   // Priority Mail International Medium Flat Rate Box
  usps_int_10                           : 'usps_4',   // Priority Mail Express International Flat Rate Envelope
  usps_int_11                           : 'usps_4',   // Priority Mail International Large Flat Rate Box
  usps_int_12                           : 'usps_4',   // USPS GXG Envelopes
  usps_int_13                           : 'usps_4',   // First Class Mail International Letter
  usps_int_14                           : 'usps_4',   // First Class Mail International Large Envelope
  usps_int_15                           : 'usps_4',   // First Class Package International Service
  usps_int_16                           : 'usps_4',   // Priority Mail Interntional Small Flat Rate Box
  usps_int_17                           : 'usps_4',   // Priority Mail Express International Legal Flat Rate Envelope
  usps_int_18                           : 'usps_4',   // Priority Mail International Gift Card Flat Rate Envelope
  usps_int_19                           : 'usps_4',   // Priority Mail International Window Flat Rate Envelope
  usps_int_20                           : 'usps_4',   // Priority Mail International Small Flat Rate Envelope
  usps_int_21                           : 'usps_4',   // First Class Mail International Postcard
  usps_int_22                           : 'usps_4',   // Priority Mail International Legal Flat Rate Envelope
  usps_int_23                           : 'usps_4',   // Priority Mail International Padded Flat Rate Envelope
  usps_int_24                           : 'usps_4',   // Priority Mail International DVD Flat Rate Priced Box
  usps_int_25                           : 'usps_4',   // Priority Mail International Large Video Flat Rate Priced Box
  usps_int_26                           : 'usps_4',   // Priority Mail Express International Flat Rate Boxes
  usps_int_27                           : 'usps_4',   // Priority Mail Express International Padded Flat Rate Envelope
  'usps_first-class_mail_parcel'        : 'usps_4',
  'usps_first-class_mail_large_envelope': 'usps_4'
};

export const nextDayAirTypes = {
  // '01' : 'UPS Next Day Air',
  // '01S': 'UPS Next Day Air (Saturday)',
  // '13' : 'UPS Next Day Air Saver',
  // '14' : 'UPS Next Day Air Early',
  // '14S': 'UPS Next Day Air Early (Saturday)',
  'ups_01' : 'UPS Next Day Air',
  'ups_01S': 'UPS Next Day Air (Saturday)',
  'ups_13' : 'UPS Next Day Air Saver',
  'ups_14' : 'UPS Next Day Air Early',
  'ups_14S': 'UPS Next Day Air Early (Saturday)',
}

export const shipmentTypes = {
  // Delivery Estimate Methods
  '03'  : '11',
  '05'  : '08',
  '01'  : '07',
  '21'  : '54',
  '28'  : '65',
  '1DM' : '14',
  '1DMS': '14S',
  '1DA' : '01',
  '1DAS': '01S',
  '1DP' : '13',
  '2DA' : '02',
  '2DAS': '02S',
  '2DM' : '59',
  '3DS' : '12',
  'GND' : '03',
  'M4'  : 'M4',

  // UPS Methods
  // freeshipping_freeshipping: 'M4',
  freeshipping_usps_0_FCP  : 'M4',
  freeshipping_freeshipping: '03',
  freeshipping_ups01       : '01',
  freeshipping_ups02       : '02',
  freeshipping_ups03       : '03',
  freeshipping_ups_01      : '01',
  freeshipping_ups_02      : '02',
  freeshipping_ups_03      : '03',
  // flatrate_flatrate        : 'M4',
  flatrate_flatrate        : '03',
  flatrate_ups_03          : '03',
  flatrate_ups_02          : '02',
  flatrate_ups_01          : '01',
  superrush_superrush      : '01',
  ups_01                   : '01',   // UPS Next Day Air
  ups_01S                  : '01S',  // UPS Next Day Air (Saturday)
  ups_02                   : '02',   // UPS 2nd Day Air
  ups_02S                  : '02S',  // UPS 2nd Day Air (Saturday)
  ups_03                   : '03',   // UPS Ground
  ups_07                   : '07',   // UPS Worldwide Express
  ups_08                   : '08',   // UPS Worldwide Expedited
  ups_11                   : '11',   // UPS Standard
  ups_12                   : '12',   // UPS Three-Day Select
  ups_13                   : '13',   // UPS Next Day Air Saver
  ups_14                   : '14',   // UPS Next Day Air Early A.M.
  ups_14S                  : '14S',  // UPS Next Day Air Early A.M. (Saturday)
  ups_54                   : '54',   // UPS Worldwide Express Plus
  ups_59                   : '59',   // UPS Second Day Air A.M.
  ups_65                   : '65',   // UPS Worldwide Saver
  ups_gnd                  : '03',
  ups_1da                  : '01',
  ups_2da                  : '02',

  // UPS Mail Innovations Methods
  usps_0_fcle                           : 'M4',   // First Class Mail Large Envelope
  usps_0_fcl                            : 'M4',   // First Class Mail Letter
  usps_0_fcp                            : 'M4',   // First Class Mail Parcel
  usps_0_fcpc                           : 'M4',   // First Class Mail Postcards
  usps_1                                : 'M4',   // Priority Mail
  usps_2                                : 'M4',   // Priority Mail Express Hold For Pickup
  usps_3                                : 'M4',   // Priority Mail Express
  usps_4                                : 'M4',   // Standard Post
  usps_6                                : 'M4',   // Media Mail
  usps_7                                : 'M4',   // Library Mail
  usps_13                               : 'M4',   // Priority Mail Express Flat Rate Envelope
  usps_15                               : 'M4',   // First Class Mail Large Postcards
  usps_16                               : 'M4',   // Priority Mail Flat Rate Envelope
  usps_17                               : 'M4',   // Priority Mail Medium Flat Rate Box
  usps_22                               : 'M4',   // Priority Mail Large Flat Rate Box
  usps_23                               : 'M4',   // Priority Mail Express Sunday/Holiday Delivery
  usps_25                               : 'M4',   // Priority Mail Express Sunday/Holiday Delivery Flat Rate Envelope
  usps_27                               : 'M4',   // Priority Mail Express Flat Rate Envelope Hold For Pickup
  usps_28                               : 'M4',   // Priority Mail Small Flat Rate Box
  usps_29                               : 'M4',   // Priority Mail Padded Flat Rate Envelope
  usps_30                               : 'M4',   // Priority Mail Express Legal Flat Rate Envelope
  usps_31                               : 'M4',   // Priority Mail Express Legal Flat Rate Envelope Hold For Pickup
  usps_32                               : 'M4',   // Priority Mail Express Sunday/Holiday Delivery Legal Flat Rate Envelope
  usps_33                               : 'M4',   // Priority Mail Hold For Pickup
  usps_34                               : 'M4',   // Priority Large Flat Rate Box Hold For Pickup
  usps_35                               : 'M4',   // Priority Medium Flat Rate Box Hold For Pickup
  usps_36                               : 'M4',   // Priority Small Flat Rate Box Hold For Pickup
  usps_37                               : 'M4',   // Priority Mail Flat Rate Envelope Hold For Pickup
  usps_38                               : 'M4',   // Priority Mail Gift Card Flat Rate Envelope
  usps_39                               : 'M4',   // Priority Mail Gift Card Flat Rate Envelope Hold For Pickup
  usps_40                               : 'M4',   // Priority Mail Window Flat Rate Envelope
  usps_41                               : 'M4',   // Priority Mail Window Flat Rate Envelope Hold For Pickup
  usps_42                               : 'M4',   // Priority Mail Small Flat Rate Envelope
  usps_43                               : 'M4',   // Priority Mail Small Flat Rate Envelope Hold For Pickup
  usps_44                               : 'M4',   // Priority Mail Legal Flat Rate Envelope
  usps_45                               : 'M4',   // Priority Mail Legal Flat Rate Envelope Hold For Pickup
  usps_46                               : 'M4',   // Priority Mail Padded Flat Rate Envelope Hold For Pickup
  usps_47                               : 'M4',   // Priority Mail Regional Rate Box A
  usps_48                               : 'M4',   // Priority Mail Regional Rate Box A Hold For Pickup
  usps_49                               : 'M4',   // Priority Mail Regional Rate Box B
  usps_50                               : 'M4',   // Priority Mail Regional Rate Box B Hold For Pickup
  usps_53                               : 'M4',   // First Class Package Service Hold For Pickup
  usps_55                               : 'M4',   // Priority Mail Express Flat Rate Boxes
  usps_56                               : 'M4',   // Priority Mail Express Flat Rate Boxes Hold For Pickup
  usps_57                               : 'M4',   // Priority Mail Express Sunday/Holiday Delivery Flat Rate Boxes
  usps_58                               : 'M4',   // Priority Mail Regional Rate Box C
  usps_59                               : 'M4',   // Priority Mail Regional Rate Box C Hold For Pickup
  usps_61                               : 'M4',   // First Class Package Service
  usps_62                               : 'M4',   // Priority Mail Express P Added Flat Rate Envelope
  usps_63                               : 'M4',   // Priority Mail Express Padded Flat Rate Envelope Hold For Pickup
  usps_64                               : 'M4',   // Priority Mail Express Sunday/Holiday Delivery Padded Flat Rate Envelope
  usps_int_1                            : 'M4',   // Priority Mail Express International
  usps_int_2                            : 'M4',   // Priority Mail International
  usps_int_4                            : 'M4',   // Global Express Guaranteed (GXG)
  usps_int_5                            : 'M4',   // Global Express Guaranteed Document
  usps_int_6                            : 'M4',   // Global Express Guaranteed Non-Document Rectangular
  usps_int_7                            : 'M4',   // Global Express Guaranteed Non-Document Non-Rectangular
  usps_int_8                            : 'M4',   // Priority Mail International Flat Rate Envelope
  usps_int_9                            : 'M4',   // Priority Mail International Medium Flat Rate Box
  usps_int_10                           : 'M4',   // Priority Mail Express International Flat Rate Envelope
  usps_int_11                           : 'M4',   // Priority Mail International Large Flat Rate Box
  usps_int_12                           : 'M4',   // USPS GXG Envelopes
  usps_int_13                           : 'M4',   // First Class Mail International Letter
  usps_int_14                           : 'M4',   // First Class Mail International Large Envelope
  usps_int_15                           : 'M4',   // First Class Package International Service
  usps_int_16                           : 'M4',   // Priority Mail Interntional Small Flat Rate Box
  usps_int_17                           : 'M4',   // Priority Mail Express International Legal Flat Rate Envelope
  usps_int_18                           : 'M4',   // Priority Mail International Gift Card Flat Rate Envelope
  usps_int_19                           : 'M4',   // Priority Mail International Window Flat Rate Envelope
  usps_int_20                           : 'M4',   // Priority Mail International Small Flat Rate Envelope
  usps_int_21                           : 'M4',   // First Class Mail International Postcard
  usps_int_22                           : 'M4',   // Priority Mail International Legal Flat Rate Envelope
  usps_int_23                           : 'M4',   // Priority Mail International Padded Flat Rate Envelope
  usps_int_24                           : 'M4',   // Priority Mail International DVD Flat Rate Priced Box
  usps_int_25                           : 'M4',   // Priority Mail International Large Video Flat Rate Priced Box
  usps_int_26                           : 'M4',   // Priority Mail Express International Flat Rate Boxes
  usps_int_27                           : 'M4',   // Priority Mail Express International Padded Flat Rate Envelope
  'usps_first-class_mail_parcel'        : 'M4',
  'usps_first-class_mail_large_envelope': 'M4'
};

export const shipmentDisplayTypes = {
  // UPS
  // freeshipping_freeshipping: 'UPS Mail Innovations',
  freeshipping_usps_0_FCP  : 'UPS Mail Innovations',
  freeshipping_freeshipping: 'UPS Ground',
  freeshipping_ups01       : 'UPS Next Day Air',
  freeshipping_ups02       : 'UPS 2nd Day Air',
  freeshipping_ups03       : 'UPS Ground',
  freeshipping_ups_01      : 'UPS Next Day Air',
  freeshipping_ups_02      : 'UPS 2nd Day Air',
  freeshipping_ups_03      : 'UPS Ground',
  // flatrate_flatrate        : 'UPS Mail Innovations',
  flatrate_flatrate        : 'UPS Ground',
  flatrate_ups_03          : 'UPS Ground',
  flatrate_ups_02          : 'UPS 2nd Day Air',
  flatrate_ups_01          : 'UPS Next Day Air',
  superrush_superrush      : 'UPS Next Day Air',
  ups_01                   : 'UPS Next Day Air',
  ups_01S                  : 'UPS Next Day Air (Saturday)',
  ups_02                   : 'UPS 2nd Day Air',
  ups_02S                  : 'UPS 2nd Day Air (Saturday)',
  ups_03                   : 'UPS Ground',
  ups_07                   : 'UPS Worldwide Express',
  ups_08                   : 'UPS Worldwide Expedited',
  ups_11                   : 'UPS Standard',
  ups_12                   : 'UPS 3 Day Select',
  ups_13                   : 'UPS Next Day Air Saver',
  ups_14                   : 'UPS Next Day Air Early',
  ups_14S                  : 'UPS Next Day Air Early (Saturday)',
  ups_54                   : 'UPS Worldwide Express Plus',
  ups_59                   : 'UPS Second Day Air A.M.',
  ups_65                   : 'UPS Worldwide Saver',

  // UPS Mail Innovations
  usps_0_fcle: 'UPS Mail Innovations',
  usps_0_fcl : 'UPS Mail Innovations',
  usps_0_fcp : 'UPS Mail Innovations',
  usps_0_fcpc: 'UPS Mail Innovations',
  usps_1     : 'UPS Mail Innovations',
  usps_2     : 'UPS Mail Innovations',
  usps_3     : 'UPS Mail Innovations',
  usps_4     : 'UPS Mail Innovations',
  usps_6     : 'UPS Mail Innovations',
  usps_7     : 'UPS Mail Innovations',
  usps_13    : 'UPS Mail Innovations',
  usps_15    : 'UPS Mail Innovations',
  usps_16    : 'UPS Mail Innovations',
  usps_17    : 'UPS Mail Innovations',
  usps_22    : 'UPS Mail Innovations',
  usps_23    : 'UPS Mail Innovations',
  usps_25    : 'UPS Mail Innovations',
  usps_27    : 'UPS Mail Innovations',
  usps_28    : 'UPS Mail Innovations',
  usps_29    : 'UPS Mail Innovations',
  usps_30    : 'UPS Mail Innovations',
  usps_31    : 'UPS Mail Innovations',
  usps_32    : 'UPS Mail Innovations',
  usps_33    : 'UPS Mail Innovations',
  usps_34    : 'UPS Mail Innovations',
  usps_35    : 'UPS Mail Innovations',
  usps_36    : 'UPS Mail Innovations',
  usps_37    : 'UPS Mail Innovations',
  usps_38    : 'UPS Mail Innovations',
  usps_39    : 'UPS Mail Innovations',
  usps_40    : 'UPS Mail Innovations',
  usps_41    : 'UPS Mail Innovations',
  usps_42    : 'UPS Mail Innovations',
  usps_43    : 'UPS Mail Innovations',
  usps_44    : 'UPS Mail Innovations',
  usps_45    : 'UPS Mail Innovations',
  usps_46    : 'UPS Mail Innovations',
  usps_47    : 'UPS Mail Innovations',
  usps_48    : 'UPS Mail Innovations',
  usps_49    : 'UPS Mail Innovations',
  usps_50    : 'UPS Mail Innovations',
  usps_53    : 'UPS Mail Innovations',
  usps_55    : 'UPS Mail Innovations',
  usps_56    : 'UPS Mail Innovations',
  usps_57    : 'UPS Mail Innovations',
  usps_58    : 'UPS Mail Innovations',
  usps_59    : 'UPS Mail Innovations',
  usps_61    : 'UPS Mail Innovations',
  usps_62    : 'UPS Mail Innovations',
  usps_63    : 'UPS Mail Innovations',
  usps_64    : 'UPS Mail Innovations',
  usps_int_1 : 'UPS Mail Innovations',
  usps_int_2 : 'UPS Mail Innovations',
  usps_int_4 : 'UPS Mail Innovations',
  usps_int_5 : 'UPS Mail Innovations',
  usps_int_6 : 'UPS Mail Innovations',
  usps_int_7 : 'UPS Mail Innovations',
  usps_int_8 : 'UPS Mail Innovations',
  usps_int_9 : 'UPS Mail Innovations',
  usps_int_10: 'UPS Mail Innovations',
  usps_int_11: 'UPS Mail Innovations',
  usps_int_12: 'UPS Mail Innovations',
  usps_int_13: 'UPS Mail Innovations',
  usps_int_14: 'UPS Mail Innovations',
  usps_int_15: 'UPS Mail Innovations',
  usps_int_16: 'UPS Mail Innovations',
  usps_int_17: 'UPS Mail Innovations',
  usps_int_18: 'UPS Mail Innovations',
  usps_int_19: 'UPS Mail Innovations',
  usps_int_20: 'UPS Mail Innovations',
  usps_int_21: 'UPS Mail Innovations',
  usps_int_22: 'UPS Mail Innovations',
  usps_int_23: 'UPS Mail Innovations',
  usps_int_24: 'UPS Mail Innovations',
  usps_int_25: 'UPS Mail Innovations',
  usps_int_26: 'UPS Mail Innovations',
  usps_int_27: 'UPS Mail Innovations'
}

export const shipmentPackageTypes = {
  '01'                       : 'UPS Letter',
  '02'                       : 'Customer Supplied Package',
  '03'                       : 'Tube',
  '04'                       : 'PAK',
  '21'                       : 'UPS Express Box',
  '24'                       : 'UPS 25KG Box',
  '25'                       : 'UPS 10KG Box',
  '30'                       : 'Pallet',
  '2a'                       : 'Small Express Box',
  '2b'                       : 'Medium Express Box',
  '2c'                       : 'Large Express Box',
  '56'                       : 'Flats',
  '57'                       : 'Parcels',
  '58'                       : 'BPM',
  '59'                       : 'First Class',
  '60'                       : 'Priority',
  '61'                       : 'Machinables',
  '62'                       : 'Irregulars',
  '63'                       : 'Parcel Post',
  '64'                       : 'BPM Parcel',
  '65'                       : 'Media Mail',
  '66'                       : 'BPM Flat',
  '67'                       : 'Standard Flat',
  'UPS Letter'               : '01',
  'Customer Supplied Package': '02',
  'Tube'                     : '03',
  'PAK'                      : '04',
  'UPS Express Box'          : '21',
  'UPS 25KG Box'             : '24',
  'UPS 10KG Box'             : '25',
  'Pallet'                   : '30',
  'Small Express Box'        : '2a',
  'Medium Express Box'       : '2b',
  'Large Express Box'        : '2c',
  'Flats'                    : '56',
  'Parcels'                  : '57',
  'BPM'                      : '58',
  'First Class'              : '59',
  'Priority'                 : '60',
  'Machinables'              : '61',
  'Irregulars'               : '62',
  'Parcel Post'              : '63',
  'BPM Parcel'               : '64',
  'Media Mail'               : '65',
  'BPM Flat'                 : '66',
  'Standard Flat'            : '67'
};

/**
 * AMAZON Related Logic
 */
export const amazonDfType = {
  'AMZL_US_BULK' : 'Amazon Direct Fufillment', 
  'AMZL_US_LMA' : 'Amazon Direct Fufillment', 
  'AMZL_US_PREMIUM' : 'Amazon Direct Fufillment',
  'AMZL_US_LMA_AIR' : 'Amazon Direct Fufillment', 
  'AMZL_US_PREMIUM_AIR' : 'Amazon Direct Fufillment',
  'USPS_ATS_BPM' : 'Amazon Direct Fufillment',
  'USPS_ATS_STD' : 'Amazon Direct Fufillment',
  'USPS_ATS_PARCEL' : 'Amazon Direct Fufillment',
  'USPS_ATS_BPM_AIR' : 'Amazon Direct Fufillment',
  'USPS_ATS_STD_AIR' : 'Amazon Direct Fufillment',
  'USPS_ATS_PARCEL_AIR' : 'Amazon Direct Fufillment',
  'AT_SC_BULK' : 'Amazon Direct Fufillment',  
  'AT_SC_DIRECT' : 'Amazon Direct Fufillment',
  'JW_SC_BULK' : 'Amazon Direct Fufillment',
  'JW_SC_DIRECT' : 'Amazon Direct Fufillment',
  'LA_SC_BULK' : 'Amazon Direct Fufillment',
  'LA_SC_DIRECT' : 'Amazon Direct Fufillment',
  'OT_SC_BULK' : 'Amazon Direct Fufillment',
  'OT_SC_DIRECT' : 'Amazon Direct Fufillment',
  'PA_SC_BULK' : 'Amazon Direct Fufillment', 
  'PA_SC_DIRECT' : 'Amazon Direct Fufillment',
  'AMZL_US_SH' : 'Amazon Direct Fufillment',
  'AMZL_US_SH_SD' : 'Amazon Direct Fufillment',
  'AMZL_US_SH_PARCEL' : 'Amazon Direct Fufillment',
};

/**
 * FedEx Related Logic
 */
export const DomFedExServiceHierarchy = [
  "SAME_DAY",
  "SAME_DAY_CITY",
  "FIRST_OVERNIGHT",
  "PRIORITY_OVERNIGHT",
  "STANDARD_OVERNIGHT",
  "FEDEX_2_DAY",
  "FEDEX_2_DAY_AM",
  "FEDEX_EXPRESS_SAVER",
  "FEDEX_GROUND",
  "GROUND_HOME_DELIVERY",
  "SMART_POST",
]
export const IntlFedExServiceHierarchy = [
  "INTERNATIONAL_FIRST",
  "FEDEX_INTERNATIONAL_PRIORITY_EXPRESS",
  "FEDEX_INTERNATIONAL_PRIORITY",
  "INTERNATIONAL_PRIORITY_DISTRIBUTION",
  "FEDEX_CARGO_INTERNATIONAL_PREMIUM",
  "FEDEX_CARGO_AIRPORT_TO_AIRPORT",
  "INTERNATIONAL_ECONOMY",
  "INTL_GROUND_DISTRIBUTION",
]

export const FedExServiceFreightsHierarchy = [
  "FEDEX_1_DAY_FREIGHT",
  "FEDEX_FIRST_FREIGHT",
  "INTERNATIONAL_PRIORITY_FREIGHT",
  "FEDEX_IP_DIRECT_DISTRIBUTION_FREIGHT",
  "FEDEX_2_DAY_FREIGHT",
  "INTERNATIONAL_ECONOMY_FREIGHT",
  "FEDEX_3_DAY_FREIGHT",
]

export const FedExServiceTypeMapping = {
  "FedEx International Priority® Express"                                            : "FEDEX_INTERNATIONAL_PRIORITY_EXPRESS",
  "FedEx International First®"                                                       : "INTERNATIONAL_FIRST",
  "FedEx International Priority®"                                                    : "FEDEX_INTERNATIONAL_PRIORITY",
  "FedEx International Economy®"                                                     : "INTERNATIONAL_ECONOMY",
  "FedEx Ground"                                                                     : "FEDEX_GROUND",
  "FedEx International Premium®"                                                     : "FEDEX_CARGO_INTERNATIONAL_PREMIUM",
  "FedEx First Overnight®"                                                           : "FIRST_OVERNIGHT",
  "FedEx First Overnight® Freight"                                                   : "FEDEX_FIRST_FREIGHT",
  "FedEx 1Day® Freight  (Hawaii service is to and from the island of Oahu only)"     : "FEDEX_1_DAY_FREIGHT",
  "FedEx 2Day® Freight (Hawaii service is to and from the island of Oahu only)"      : "FEDEX_2_DAY_FREIGHT",
  "FedEx 3Day® Freight (Except Alaska and Hawaii)"                                   : "FEDEX_3_DAY_FREIGHT",
  "FedEx International Priority® Freight"                                            : "INTERNATIONAL_PRIORITY_FREIGHT",
  "FedEx International Economy® Freight"                                             : "INTERNATIONAL_ECONOMY_FREIGHT",
  "FedEx International Express Freight® and FedEx International Airport-to-AirportSM": "FEDEX_CARGO_AIRPORT_TO_AIRPORT",
  "FedEx International Priority DirectDistribution®"                                 : "INTERNATIONAL_PRIORITY_DISTRIBUTION",
  "FedEx International Priority DirectDistribution® Freight"                         : "FEDEX_IP_DIRECT_DISTRIBUTION_FREIGHT",
  "International Ground® Distribution (IGD)"                                         : "INTL_GROUND_DISTRIBUTION",
  "FedEx Home Delivery"                                                              : "GROUND_HOME_DELIVERY",
  "FedEx SmartPost"                                                                  : "SMART_POST",
  "FedEx Priority Overnight®"                                                        : "PRIORITY_OVERNIGHT",
  "FedEx Standard Overnight"                                                         : "STANDARD_OVERNIGHT",
  "FedEx 2Day® (Except Intra-Hawaii)"                                                : "FEDEX_2_DAY",
  "FedEx 2Day® AM (Hawaii outbound only)"                                            : "FEDEX_2_DAY_AM",
  "FedEx Express Saver® (Except Alaska and Hawaii)"                                  : "FEDEX_EXPRESS_SAVER",
  "FedEx SameDay®"                                                                   : "SAME_DAY",
  "FedEx SameDay® City (Selected U.S. Metro Areas)"                                  : "SAME_DAY_CITY",

  "FedEx First Overnight® (Saturday)"                                                : "FIRST_OVERNIGHT_SATURDAY",
  "FedEx Priority Overnight® (Saturday)"                                             : "PRIORITY_OVERNIGHT_SATURDAY",
  "FedEx Standard Overnight (Saturday)"                                              : "STANDARD_OVERNIGHT_SATURDAY",
  "FedEx 2Day® (Saturday)"                                                           : "FEDEX_2_DAY_SATURDAY",
  "FedEx 2Day® AM (Saturday - Hawaii outbound only)"                                 : "FEDEX_2_DAY_AM_SATURDAY",
  
  "FEDEX_INTERNATIONAL_PRIORITY_EXPRESS": "FedEx International Priority® Express",
  "INTERNATIONAL_FIRST"                 : "FedEx International First®",
  "FEDEX_INTERNATIONAL_PRIORITY"        : "FedEx International Priority®",
  "INTERNATIONAL_ECONOMY"               : "FedEx International Economy®",
  "FEDEX_GROUND"                        : "FedEx Ground",
  "FEDEX_CARGO_INTERNATIONAL_PREMIUM"   : "FedEx International Premium®",
  "FIRST_OVERNIGHT"                     : "FedEx First Overnight®",
  "FEDEX_FIRST_FREIGHT"                 : "FedEx First Overnight® Freight",
  "FEDEX_1_DAY_FREIGHT"                 : "FedEx 1Day® Freight  (Hawaii service is to and from the island of Oahu only)",
  "FEDEX_2_DAY_FREIGHT"                 : "FedEx 2Day® Freight (Hawaii service is to and from the island of Oahu only)",
  "FEDEX_3_DAY_FREIGHT"                 : "FedEx 3Day® Freight (Except Alaska and Hawaii)",
  "INTERNATIONAL_PRIORITY_FREIGHT"      : "FedEx International Priority® Freight",
  "INTERNATIONAL_ECONOMY_FREIGHT"       : "FedEx International Economy® Freight",
  "FEDEX_CARGO_AIRPORT_TO_AIRPORT"      : "FedEx International Express Freight® and FedEx International Airport-to-AirportSM",
  "INTERNATIONAL_PRIORITY_DISTRIBUTION" : "FedEx International Priority DirectDistribution®",
  "FEDEX_IP_DIRECT_DISTRIBUTION_FREIGHT": "FedEx International Priority DirectDistribution® Freight",
  "INTL_GROUND_DISTRIBUTION"            : "International Ground® Distribution (IGD)",
  "GROUND_HOME_DELIVERY"                : "FedEx Home Delivery",
  "SMART_POST"                          : "FedEx SmartPost",
  "PRIORITY_OVERNIGHT"                  : "FedEx Priority Overnight®",
  "STANDARD_OVERNIGHT"                  : "FedEx Standard Overnight",
  "FEDEX_2_DAY"                         : "FedEx 2Day® (Except Intra-Hawaii)",
  "FEDEX_2_DAY_AM"                      : "FedEx 2Day® AM (Hawaii outbound only)",
  "FEDEX_EXPRESS_SAVER"                 : "FedEx Express Saver® (Except Alaska and Hawaii)",
  "SAME_DAY"                            : "FedEx SameDay®",
  "SAME_DAY_CITY"                       : "FedEx SameDay® City (Selected U.S. Metro Areas)",
  "FIRST_OVERNIGHT_SATURDAY"            : "FedEx First Overnight® (Saturday)",
  "PRIORITY_OVERNIGHT_SATURDAY"         : "FedEx Priority Overnight® (Saturday)",
  "STANDARD_OVERNIGHT_SATURDAY"         : "FedEx Standard Overnight (Saturday)",
  "FEDEX_2_DAY_SATURDAY"                : "FedEx 2Day® (Saturday)",
  "FEDEX_2_DAY_AM_SATURDAY"             : "FedEx 2Day® AM (Saturday - Hawaii outbound only)",

  "FEDEX_GR_RES"                        : "FEDEX_GROUND"
}

// These are not official FedEx services, but we need these to request special Saturday services like we do for UPS
export const FedExSaturdayServices = [
  "FIRST_OVERNIGHT_SATURDAY",
  "PRIORITY_OVERNIGHT_SATURDAY",
  "STANDARD_OVERNIGHT_SATURDAY",
  "FEDEX_2_DAY_SATURDAY",
  "FEDEX_2_DAY_AM_SATURDAY",
] // 5 Total


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/shipment-options.ts